export const normalizeRowId = (id) => String(id);

export const getPageRowIds = (rows = []) =>
  rows.map((row) => normalizeRowId(row._id || row.id)).filter(Boolean);

export const isRowSelected = (selectedIds, rowId) => {
  if (selectedIds instanceof Set) {
    return selectedIds.has(normalizeRowId(rowId));
  }
  const key = normalizeRowId(rowId);
  return selectedIds.some((id) => normalizeRowId(id) === key);
};

export const toggleRowSelection = (selectedIds, rowId) => {
  const key = normalizeRowId(rowId);
  const exists = selectedIds.some((id) => normalizeRowId(id) === key);
  if (exists) {
    return selectedIds.filter((id) => normalizeRowId(id) !== key);
  }
  return [...selectedIds, key];
};

export const isPageFullySelected = (selectedIds, pageIds) => {
  if (!pageIds || pageIds.length === 0) return false;
  const set = selectedIds instanceof Set ? selectedIds : new Set(selectedIds.map(normalizeRowId));
  return pageIds.every((id) => set.has(normalizeRowId(id)));
};

export const isPagePartiallySelected = (selectedIds, pageIds) => {
  if (!pageIds || pageIds.length === 0) return false;
  const set = selectedIds instanceof Set ? selectedIds : new Set(selectedIds.map(normalizeRowId));
  let matchCount = 0;
  for (let i = 0; i < pageIds.length; i++) {
    if (set.has(normalizeRowId(pageIds[i]))) {
      matchCount++;
    }
  }
  return matchCount > 0 && matchCount < pageIds.length;
};

export const countSelectedOnPage = (selectedIds, pageIds) => {
  if (!pageIds || pageIds.length === 0) return 0;
  const set = selectedIds instanceof Set ? selectedIds : new Set(selectedIds.map(normalizeRowId));
  let count = 0;
  for (let i = 0; i < pageIds.length; i++) {
    if (set.has(normalizeRowId(pageIds[i]))) count++;
  }
  return count;
};

export const togglePageSelection = (selectedIds, pageIds) => {
  if (isPageFullySelected(selectedIds, pageIds)) {
    const pageIdSet = new Set(pageIds.map(normalizeRowId));
    return selectedIds.filter((id) => !pageIdSet.has(normalizeRowId(id)));
  }

  const existing = new Set(selectedIds.map(normalizeRowId));
  const merged = [...selectedIds];
  pageIds.forEach((id) => {
    const key = normalizeRowId(id);
    if (!existing.has(key)) {
      merged.push(key);
      existing.add(key);
    }
  });
  return merged;
};

export const mergePageSelection = (selectedIds, pageIds, shouldSelect) => {
  if (!shouldSelect) {
    const pageIdSet = new Set(pageIds.map(normalizeRowId));
    return selectedIds.filter((id) => !pageIdSet.has(normalizeRowId(id)));
  }

  const existing = new Set(selectedIds.map(normalizeRowId));
  const merged = [...selectedIds];
  pageIds.forEach((id) => {
    const key = normalizeRowId(id);
    if (!existing.has(key)) {
      merged.push(key);
      existing.add(key);
    }
  });
  return merged;
};
